/**
 * DGII e-CF Formato v1.0 sección A campo 38 — threshold at which
 * `RNCComprador` becomes Condicional 2 (required) for E32 (Factura
 * de Consumo Electrónica). Same rule also applies to E33/E34 that
 * modify an E32 with MontoTotal ≥ this amount. Amount is in DOP.
 *
 * Both the backend `invoice-to-ecf-mapper.service.ts` guard and the
 * FE `useCreateInvoice` hook read from this constant so drift is
 * impossible.
 */
export const ECF_E32_LARGE_AMOUNT_THRESHOLD_DOP = 250_000;

/**
 * DGII Formato 608 "Tipo Anulación" — operator picks one of these
 * codes when cancelling an invoice with a NCF. The 608 export
 * reads `invoice.annulment_reason_code` and uses '02' as fallback
 * for legacy rows.
 *
 * Codes per DGII Norma 06-18 / Formato 608 spec.
 */
export const DGII_ANNULMENT_CODES = [
  { code: '01', label: 'Deterioro de factura pre-impresa' },
  { code: '02', label: 'Errores de impresión' },
  { code: '03', label: 'Impresión defectuosa' },
  { code: '04', label: 'Duplicidad de factura' },
  { code: '05', label: 'Corrección de información' },
  { code: '06', label: 'Cambio de productos' },
  { code: '07', label: 'Devolución de productos' },
  { code: '08', label: 'Omisión de productos' },
  { code: '09', label: 'Errores en secuencia de NCF' },
  { code: '10', label: 'Cese de operaciones' },
  { code: '11', label: 'Pérdida o hurto de talonarios' },
] as const;

export type DgiiAnnulmentCode = (typeof DGII_ANNULMENT_CODES)[number]['code'];

export const DGII_ANNULMENT_CODE_VALUES = DGII_ANNULMENT_CODES.map(
  (c) => c.code
) as readonly DgiiAnnulmentCode[];
